import { landlineForDisplay } from "./landline";

// The seller's phone numbers as the invoice PDFs print them: the CEO's mobile
// (CEOContact) and landline (CEOLandline). A number the company does not have
// comes back "", and the templates leave its whole row out - an invoice never
// shows a "Landline:" with nothing after it.
//
// The app's invoice PDF does the same in src/utils/invoicePdf.ts.

/**
 * The CEO's mobile as stored (923001234567), printed the local way like the
 * landline - 0300-1234567, no +92 - or "".
 */
export const mobileForInvoice = (stored) => {
  const digits = String(stored ?? "").replace(/\D/g, "");
  const local = digits.replace(/^92/, "");
  // A form that saved an empty number left just the country code behind.
  if (!local) return "";
  return /^3[0-9]{9}$/.test(local)
    ? `0${local.slice(0, 3)}-${local.slice(3)}`
    : digits;
};

/** The seller card's phone rows, [label, value] - only the numbers it has. */
export const sellerPhoneRows = (company) =>
  [
    ["Contact:", mobileForInvoice(company?.CEOContact)],
    ["Landline:", landlineForDisplay(company?.CEOLandline)],
  ].filter(([, value]) => value);
